"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FormFields = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col"
  }, props.children);
};
var _default = exports.default = FormFields;